import "./css/ExperienceCard.scss";
import Card from "react-bootstrap/Card";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";

function ExperienceCard(props) {
  return (
    <>
      <Card className="ExperienceCard d-inline-block">
        <Card.Header className="p-3 d-flex flex-column">
          <Card.Title className="fw-bold">{props.experience.companyName}</Card.Title>
          <Card.Subtitle className="text-muted">
            <div className="d-flex flex-column gap-1">
              <span>{props.experience.jobTitle}</span>
              <span>{props.experience.startDate} - {props.experience.endDate}</span>
            </div>
          </Card.Subtitle>
          {props.experience.companySiteUrl &&
            <Button className="mt-2 ms-auto d-flex align-items-center gap-2" as="a" variant="primary" href={props.experience.companySiteUrl} target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/fluency-systems-regular/20/FFFFFF/external-link.png" alt="External link icon" />
              Visit company site
            </Button>}
        </Card.Header>

        <Card.Body>
          <Tabs className="mb-3" fill>
            <Tab eventKey="summary" title="Summary">
              {props.experience.summary.caption &&
                <Card.Text>{props.experience.summary.caption}</Card.Text>}
              <ListGroup as="ol" variant="flush" numbered>
                {
                  Object.values(props.experience.summary.list).map((highlight, index) =>
                    <ListGroup.Item key={index} className="d-flex gap-2" as="li">
                      {highlight.heading ?
                        <div className="d-flex flex-column">
                          <div className="fw-bold">{highlight.heading}</div>
                          <div>{highlight.text}</div>
                        </div>
                        : <div>{highlight.text}</div>}
                    </ListGroup.Item>
                  )
                }
              </ListGroup>
            </Tab>

            <Tab eventKey="toolsAndTechnologies" title="Tools & Technologies">
              {props.experience.toolsAndTechnologies.caption &&
                <Card.Text>{props.experience.toolsAndTechnologies.caption}</Card.Text>}
              <ListGroup as="ol" variant="flush" numbered>
                {
                  Object.values(props.experience.toolsAndTechnologies.list).map((item, index) =>
                    <ListGroup.Item key={index} className="d-flex gap-2" as="li">
                      {item.heading ?
                        <div className="d-flex flex-column">
                          <div className="fw-bold">{item.heading}</div>
                          <div>{item.text}</div>
                        </div>
                        : <div>{item.text}</div>}
                    </ListGroup.Item>
                  )
                }
              </ListGroup>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </>
  );
}

export default ExperienceCard;